import type { FaireProductEntity } from "../../entity_types/product";

export const p_kw7qepc4xq: FaireProductEntity = {
  token: "p_kw7qepc4xq",
  type: "product",
  name: "Metal Fruit Hair Claw Clip, Mini Rhinestone Hair Clip",
  brandToken: "b_xttg6nwn4k",
  brandName: "SoapElenGlen",
  imageUrl:
    "https://cdn.faire.com/fastly/b58ffd66e779ddda85b90ca32e2aa5170ff134829f24f81d28a88854190b0baa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4cdf31057dc3e544aaa17db37f0a0b8606a1f54e1caad787df40c169c82a8c2c.jpeg",
    "https://cdn.faire.com/fastly/6e76e5e7fdfc942ae94f8004f32c4cacff268203f64bab36a293091ee2bca3c8.jpeg",
    "https://cdn.faire.com/fastly/63a081ebb1588b72bb14119c363eb6434f649419259ea82776ec32f44b69f52c.jpeg",
    "https://cdn.faire.com/fastly/734887bbda72e3ab074eb8436748214619a64ffda2b2420920eeeafb60f6e5b7.jpeg",
    "https://cdn.faire.com/fastly/cb33314e98560c5f7a611b970fd2e344df1ca8adacbb223f5efdd0f9ce949282.jpeg",
    "https://cdn.faire.com/fastly/972fdf88e9eabfacfb0881b3a1e02cf3ce20e042dfb8ae0f7a88050b024d8e76.jpeg",
    "https://cdn.faire.com/fastly/a294903adec50f60be2a21043120ab5c1eaf96c301bcd0eb50ed1678d488632c.jpeg",
    "https://cdn.faire.com/fastly/ebe94ed8d14baafebce5150c07a4ec56989982f4567feb95a748b74cbc8a7727.jpeg",
    "https://cdn.faire.com/fastly/a066991dbc05c33958b2440309882649761f23acee05578bdaa8c44ae85ad7be.jpeg",
    "https://cdn.faire.com/fastly/48720b8c56f8ea322e002aa35c24c7b601f68750307a4b05a07e2012a137e10c.jpeg",
    "https://cdn.faire.com/fastly/11baa875992ee72eb1a57b07fefcbbd10a097357f10bce14728eb4697bba4a5a.jpeg",
  ],
  priceDollars: 2.04,
  description:
    "Size: 2.5cm\nWeight: 10g\nMaterial: Alloy, Rhinestones\n\n\nAdd a playful sparkle to your look with this metal fruit hair claw clip. Accented with shimmering rhinestones and crafted in a mini size, it’s both charming and practical. Whether you’re styling a casual updo or adding a fun detail to your outfit, this cute hair clip brings a fresh and lively touch to any hairstyle.",
  tags: [],
  msrpDollars: 4.07,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:57.403Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
